import React, { useState } from "react";
import CreateForm from "../UIResuableComponents/CreateForm/CreateForm";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/User/AuthSlice";
import { Success, Error } from "../UIResuableComponents/Error/ErrorSuccess";
function Login() {
  const FormOptions = [
    //data to create form

    {
      type: "email",
      labelName: "Email",
      placeholder: "Enter email",
      isRequired: false,
      valueLabel: "email",
    },
    {
      type: "password",
      labelName: "Password",
      placeholder: "Enter password",
      isRequired: false,
      valueLabel: "password",
    },
  ];
  const InitialFormData = {
    email: "",
    password: "",
  };
  const ErrorData = {
    email: "",
    password: "",
  };
  const [userAuth, setUserAuth] = useState(InitialFormData);

  const dispatch = useDispatch();

  // form input change handler
  const onInputChangeHandler = (inputName, inputValue) => {
    const formData = { ...userAuth };
    formData[inputName] = inputValue;
    setUserAuth(formData);
  };
  // function to subit login credentials
  const setLoginHandler = (e) => {
    e.preventDefault();

    // dispatch(loginUser());
    setUserAuth(InitialFormData);
  };
  return (
    <>
      <CreateForm
        setListHandler={setLoginHandler}
        onInputChangeHandler={onInputChangeHandler}
        inputFormData={userAuth}
        FormOptions={FormOptions}
        isLogo={true}
        CreateName="Login"
        createOrUpdate={"Login"}
        // form style css for login
        FormStyle="!shadow-none max-w-md top-[37%]"
        isNotCancelBtn={true}
        ErrorData={ErrorData}
      >
        {/* children function to add extra filed for form */}
        <div className="text-center mt-4">
          <p className="text-xs">
            <span>Forgot your password?</span>
            <span className="text-btnbgcolor ml-1">
              <Link to="/reset">Reset Password</Link>
            </span>
          </p>
        </div>
      </CreateForm>
    </>
  );
}

export default Login;
